export const TEMPLATE_NAME = {
    GENERIC: 'generic',
    DRILLDOWN: 'drilldown',
    MEMBER_DETAIL: 'memberDetail',
    ACCORDION: 'accordion',
    DOCUMENT_LIST: 'documentList',
    RETIREMENT_CALC: 'retirementCalc',
    RETIREE_PAYROLL_HISTORY: 'payrollHistory'
  };